<template>
  <div v-if="headerActive">
    <v-row class="sabs-header flex align-center mb-0">
      <v-toolbar color="#014386">
        <div class="logo">
          <router-link to="/"
            ><img src="@/assets/nzfts-logo-notag.svg" alt="Salvation Army Banking System"
          /></router-link>
        </div>
        <v-toolbar-title
          ><router-link to="/" class="text-white">SABS 2.0</router-link></v-toolbar-title
        >
        <v-toolbar-items class="hidden-sm-and-down">
          <v-btn :to="{ name: 'bankAccounts' }" flat> Bank Accounts </v-btn>
          <v-btn :to="{ name: 'transactions' }" flat> Transaction Reports </v-btn>
          <v-btn @click="transactionStillToProcess" flat> Still to Process </v-btn>
          <v-btn :to="{ name: 'exports' }" flat> Exports </v-btn>
          <v-btn :to="{ name: 'sweeps' }" v-if="userStore.isAdmin" flat> Sweeps </v-btn>
        </v-toolbar-items>
        <v-spacer></v-spacer>
        <v-toolbar-items class="hidden-sm-and-down" v-if="userStore.isAdmin">
          <v-btn :to="{ name: 'validation-categories' }" flat>Settings </v-btn>
        </v-toolbar-items>

        <v-menu class="hidden-md-and-up">
          <template v-slot:activator="{ props }">
            <v-app-bar-nav-icon v-bind="props" class="hidden-md-and-up"></v-app-bar-nav-icon>
          </template>
          <v-list>
            <v-list-item :to="{ name: 'bankAccounts' }">
              <v-list-item-title>Bank Accounts</v-list-item-title>
            </v-list-item>
            <v-list-item :to="{ name: 'transactions' }">
              <v-list-item-title>Transaction Reports</v-list-item-title>
            </v-list-item>
            <v-list-item @click="transactionStillToProcess">
              <v-list-item-title>Still to Process</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="userStore.isAdmin" :to="{ name: 'exports' }">
              <v-list-item-title>Exports</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="userStore.isAdmin" :to="{ name: 'validation-categories' }">
              <v-list-item-title>Settings</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="userStore.isAdmin" :to="{ name: 'sweeps' }">
              <v-list-item-title>Sweeps</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="userStore.isAdmin" :to="{ name: 'settings' }">
              <v-list-item-title>Settings</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar>
    </v-row>
    <v-row class="pt-0 mt-0">
      <v-col class="pt-0 mt-0 text-right mr-7">
        <span>logged in as: {{ userStore.displayName }}</span>
        <v-icon icon="mdi-export" class="ms-2" @click="logout"></v-icon>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { ref, watch, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { useUserStore } from '@/stores/user'
export default {
  name: 'MainHeader',
  setup() {
    const headerActive = ref(false)
    const route = useRoute()
    const router = useRouter()
    const userStore = useUserStore()

    watch(
      () => route.path,
      () => {
        headerActive.value = !route.matched.some((route) => route.meta && route.meta.hideTopBar)
      },
      { immediate: true },
    )

    onMounted(async () => {
      headerActive.value = !route.matched.some((route) => route.meta && route.meta.hideTopBar)
    })

    const logout = async () => {
      await userStore.logout()
    }

    const transactionStillToProcess = () => {
      router.push({ name: 'transactions', query: { stillToProcess: true } })
    }

    return {
      headerActive,
      logout,
      userStore,
      transactionStillToProcess,
    }
  },
}
</script>
